import Features from "../Utils/Features"

const AboutUs=()=>
{
    const data=[
        {"number":"99.9%", "value":"Client Satisfaction"},
        {"number":"15+","value":"Team Members"},
        {"number":"50+","value":"Rental MarketPlace"},
        {"number":"1400+","value":"Happy Owners"}
    ]
    return(
        <div className="sm:block lg:flex items-start lg:pl-[160px] lg:pr-[25px] sm:px-[16px] sm:pt-[30px] lg:pt-[70px] justify-between font-['Playfair Display']">
            <div className="lg:w-[600px]">
                <p style={{fontFamily:"Playfair Display"}} className="text-[#C69130] sm:text-[22px] lg:text-[32px] font-[600] sm:leading-[30px] lg:leading-[56px] lg:mb-[20px] sm:mb-[10px] tracking-[0.5px]">About us</p>
                <p style={{fontFamily:"Inter"}} className="text-[#262424] text-[16px] font-[400] sm:leading-[27px] lg:leading-[32px]">BRIK itt’s, end-to-end vacation rental management services provide convenience, expertise,
and efficient operations, allowing you to maximize your rental earnings while minimizing the
stress and workload associated with managing a vacation rental property.</p>
            </div>
            <div className="sm:mt-[20px] sm:gap-[20px] grid grid-cols-2 lg:gap-[20px] lg:mt-[0px] ">
                {
                    data?.map((e,i)=>
                    {
                        return <Features key={i} number={e.number} feature={e.value}/>
                    })
                }
            </div>
        </div>
    )
}
export default AboutUs